import { render, staticRenderFns } from "./BusinessStyle.vue?vue&type=template&id=524a36c7"
import script from "./BusinessStyle.vue?vue&type=script&lang=js"
export * from "./BusinessStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports